import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
} from "@syncfusion/ej2-react-grids";
import { Modal } from "antd";
import { useNearToExpiryScanStore } from "../../../store/useNTEScanStore";

const BasicGrid = ({}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMsg, setModalMsg] = useState("");
  const {
    gridData,
    updateScanQty,
    showQtyError,
    qtyErrorModal,
    qtyErrorMsg,
    closeQtyError,
    deleteRowById
  } = useNearToExpiryScanStore();

  const userCommands = [
    {
      type: "Delete",
      buttonOption: { cssClass: "e-flat", iconCss: "e-delete e-icons" },
    },
  ];
  const handleCommandClick = (args) => {
  if (args.commandColumn?.type === "Delete") {
    const rowData = args.rowData;
    deleteRowById(rowData.NearExpiryID);
  }
};

  const ScanQtyTemplate = (props) => {
    const [localValue, setLocalValue] = useState(
      props.scanqty ?? props.ScanQty ?? 0,
    );

    useEffect(() => {
      setLocalValue(props.scanqty ?? props.ScanQty ?? 0);
    }, [props.scanqty, props.ScanQty]);

    const handleChange = (e) => {
      const value = Math.max(0, parseInt(e.target.value || "0", 10));
      const expiryQty = props.ExpiryQty ?? 0;

      if (value > expiryQty) {
        showQtyError("Scan Qty cannot be greater than Expiry Qty");
        return;
      }

      setLocalValue(value);
    };

    const handleBlur = () => {
      updateScanQty(props.NearExpiryID, localValue);
    };

    return (
      <input
        type="number"
        min={0}
        value={localValue}
        onChange={handleChange}
        onBlur={handleBlur}
        style={{ width: "80px", padding: "4px", textAlign: "center" }}
      />
    );
  };
  let gridInstance;

  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "BrokerGrid_excelexport") {
      gridInstance.excelExport();
    }
  };
  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            <GridComponent
              ref={(g) => (gridInstance = g)}
              id="BrokerGrid"
              dataSource={gridData}
              allowPaging={true}
              allowSorting={true}
              allowFiltering={true}
              filterSettings={{ type: "Excel" }}
              toolbar={["ExcelExport", "Search"]}
              allowExcelExport={true}
              toolbarClick={toolbarClick}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
              gridLines="Both"
              height={"300px"}
              pageSettings={{
                pageSizes: [10, 20, 30, 40, 50, "All"],
                pageCount: 10,
              }}
              rowHeight={isMobile ? "" : 32}
              allowResizing={true}
              dataBound={() => {
                if (!isMobile && gridInstance) {
                  gridInstance.autoFitColumns();
                }
              }}
              commandClick={handleCommandClick}
              // frozenColumns={1}
              // rowDataBound={()}
              // commandClick={handleCommandClick}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="serialNo"
                  headerText="S No"
                  width="90"
                  textAlign="Center"
                  allowFiltering={false}
                />
                <ColumnDirective
                  field="NearExpiryID"
                  headerText="NearExpiryID"
                  width="90"
                  textAlign="Center"
                  visible={false}
                />

                <ColumnDirective
                  field="ArticleCode"
                  headerText="Item Code"
                  width="160"
                  textAlign="Left"
                />

                <ColumnDirective
                  field="ShortDesc"
                  headerText="Item Desc"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ManufacturingDate"
                  headerText="Manufacturing Date"
                  width="160"
                  type="date"
                  format="dd/MM/yyyy"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ExpiryQty"
                  headerText="Expiry QTY"
                  width="180"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="ScanQty"
                  headerText="Scan Qty"
                  width="200"
                  textAlign="Left"
                  template={ScanQtyTemplate}
                />
                <ColumnDirective
                  field="MRP"
                  headerText="MRP"
                  width="180"
                  textAlign="Left"
                />

                <ColumnDirective
                  headerText="Action"
                  commands={userCommands}
                  width="120"
                  textAlign="Center"
                  // freeze="Right"
                />
              </ColumnsDirective>

              <Inject
                services={[
                  CommandColumn,
                  Page,
                  Filter,
                  Toolbar,
                  ExcelExport,
                  Sort,
                  Group,
                  Resize,
                  Freeze,
                ]}
              />
            </GridComponent>
          </Col>
        </Row>
      </div>

      <Modal
        open={qtyErrorModal}
        footer={[
          <div
            key="ok-btn"
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "10px",
            }}
          >
            <button
              onClick={closeQtyError}
              style={{
                padding: "8px 28px",
                backgroundColor: "#1677ff",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontSize: "14px",
                cursor: "pointer",
              }}
            >
              OK
            </button>
          </div>,
        ]}
        closable={false} // ❌ remove top-right X
        centered
      >
        <p
          style={{
            fontSize: "25px", // text bada
            color: "#333",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          {qtyErrorMsg}
        </p>
      </Modal>
    </>
  );
};

export default BasicGrid;
